<div class="content-wrap tw-flex tw-flex-col tw-justify-center">
  <login-header>
    <ng-content select="[headerTitle]"></ng-content>
  </login-header>
  <div class="content">
    <ng-content></ng-content>
  </div>

  <login-footer></login-footer>
</div>
